export type TimelineNode = {
  date: string;
  tag?: string;
  title: string;
  text: string;
};

export type HotEvent = {
  id: string;
  title: string;
  category: string;
  status: '发酵中' | '持续更新' | '已告一段落';
  heat: number;
  started: string;
  updated: string;
  summary: string;
  followText?: string;
  tags: string[];
  cover: string;
  coverAlt: string;
  featured?: boolean;
  nodes: TimelineNode[];
};

export const categories = ['全部', '直播电商', '综艺幕后', '品牌舆情', '演出票务', '探店测评', '明星动态'];

export const siteStats = {
  events: 128,
  nodes: 864,
  categories: 7,
  updates: 32,
};

export const events: HotEvent[] = [
  {
    id: 'e-commerce-live',
    title: '头部主播「临场翻车」优惠口径争议事件',
    category: '直播电商',
    status: '发酵中',
    heat: 98,
    started: '2026-08-26',
    updated: '2026-09-06',
    featured: true,
    summary:
      '一场大促直播中，主播口播的“到手价”与结算页实付金额存在差异，被网友逐帧比对后引发关于直播间优惠口径的大规模讨论，平台与商家先后出面说明。',
    followText: '商家已发补充说明，消费者组织正就价格口径展开核实，事件仍在演进。',
    tags: ['直播带货', '价格口径', '消费者权益'],
    cover: 'https://readdy.ai/api/search-image?query=Top%20view%20editorial%20still%20life%20of%20a%20modern%20live%20shopping%20studio%20desk%2C%20smartphone%20showing%20a%20bright%20shopping%20stream%2C%20microphone%2C%20neat%20product%20boxes%20and%20a%20clipboard%20with%20review%20notes%2C%20warm%20cream%20and%20terracotta%20tones%2C%20soft%20natural%20window%20light%2C%20clean%20minimal%20background%2C%20high%20detail%20product%20photography%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=ev-live-01&orientation=landscape',
    coverAlt: '直播间带货优惠口径争议事件封面',
    nodes: [
      {
        date: '2026-08-26',
        tag: '爆发',
        title: '“到手价”截图开始刷屏',
        text: '大促首日，多名网友晒出同一商品的口播报价与实付截图差异，相关话题阅读量短时间攀升，评论区出现大量同款晒图。',
      },
      {
        date: '2026-08-28',
        tag: '发酵',
        title: '主播深夜直播回应',
        text: '当事主播在直播中解释“到手价”包含跨店满减与平台券叠加，称是口播简略造成的误会，并承诺对受影响订单先行补偿。',
      },
      {
        date: '2026-08-30',
        tag: '关键节点',
        title: '平台上线价格口径说明页',
        text: '电商平台针对“到手价”展示规则发布说明，明确优惠叠加顺序与页面口径，同时下架了部分存在歧义的宣传素材。',
      },
      {
        date: '2026-09-02',
        tag: '进展',
        title: '商家发补充公告并开放价保',
        text: '涉事品牌方发布补充公告，对指定时间段的订单开放价保与差价退还通道，客服排队量与退款量同步攀升。',
      },
      {
        date: '2026-09-06',
        tag: '后续',
        title: '消费者组织介入核实',
        text: '有消费者组织表示正就宣传与实付一致性展开核实，事件是否进一步升级取决于价保政策的落实进度。',
      },
    ],
  },
  {
    id: 'variety-show-editing',
    title: '《逐光舞台》导师镜头量分配争议',
    category: '综艺幕后',
    status: '发酵中',
    heat: 91,
    started: '2026-08-29',
    updated: '2026-09-05',
    summary:
      '新一期节目播出后，多位导师出镜时长被网友逐期统计，质疑剪辑镜头分配失衡，节目组回应称会调整后续剪辑方向并尊重观众反馈。',
    followText: '节目组已承诺调整，下期预告释出新的导师互动镜头，关注度仍在上升。',
    tags: ['综艺', '剪辑争议', '导师'],
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20backstage%20scene%20of%20a%20variety%20show%20studio%2C%20warm%20stage%20lights%20dimmed%2C%20director%20chairs%20and%20a%20clapperboard%2C%20cinema%20camera%20on%20tripod%2C%20amber%20and%20cream%20color%20palette%2C%20shallow%20depth%20of%20field%2C%20cozy%20theatrical%20atmosphere%2C%20high%20detail%20photography%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=ev-show-02&orientation=landscape',
    coverAlt: '综艺节目导师镜头分配争议事件封面',
    nodes: [
      {
        date: '2026-08-29',
        tag: '爆发',
        title: '导师出镜时长统计贴出圈',
        text: '有网友自制“导师镜头统计表”，逐帧比对第三期正片与花絮的出镜时长，结论被多家娱乐自媒体转载。',
      },
      {
        date: '2026-08-31',
        tag: '发酵',
        title: '粉丝站发布联名诉求',
        text: '数位导师的粉丝后援会联合发布诉求，希望节目组公开剪辑标准，讨论从“镜头量”延伸至节目公平性。',
      },
      {
        date: '2026-09-03',
        tag: '关键节点',
        title: '节目组首次回应',
        text: '官方账号发长文回应，承认部分期数叙事比重需平衡，称将采纳意见对后续剪辑进行校准，并晒出工作流程说明。',
      },
      {
        date: '2026-09-05',
        tag: '进展',
        title: '下期预告引发新讨论',
        text: '预告释出多位导师互动彩排镜头，网友对新一期是否“反向补偿”展开猜测，收视相关话题再登热搜。',
      },
    ],
  },
  {
    id: 'brand-crisis-response',
    title: '「禾野」洗护被质疑成分标注事件',
    category: '品牌舆情',
    status: '持续更新',
    heat: 82,
    started: '2026-08-18',
    updated: '2026-09-01',
    summary:
      '有博主对照产品标签与国际成分数据库，指出某宣称“精简配方”的洗护产品包装信息略显模糊，品牌方通过逐条对比回应并更新了电商详情页说明。',
    followText: '第三方送检报告已出具，品牌依据报告调整宣传文案，舆情整体回落。',
    tags: ['成分标注', '国货洗护', '品牌回应'],
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20editorial%20product%20photography%20of%20minimalist%20cream%20bottles%20and%20jars%20of%20personal%20care%20products%20on%20a%20warm%20beige%20pedestal%2C%20soft%20diffused%20daylight%2C%20clean%20laboratory%20feel%20with%20a%20clipboard%20and%20ingredient%20list%2C%20cream%20and%20terracotta%20tones%2C%20high%20detail%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=ev-brand-03&orientation=landscape',
    coverAlt: '洗护品牌成分标注争议事件封面',
    nodes: [
      {
        date: '2026-08-18',
        tag: '爆发',
        title: '博主逐条对照标签',
        text: '美妆测评博主发布长视频，对照产品全成分表与数据库，指出部分成分排序与宣称浓度存在出入，播放量迅速破百万。',
      },
      {
        date: '2026-08-20',
        tag: '发酵',
        title: '官方客服口径不一',
        text: '多位用户反馈不同客服对同一成分的答复存在差异，截图流传后进一步放大了“标注是否规范”的讨论。',
      },
      {
        date: '2026-08-23',
        tag: '关键节点',
        title: '品牌逐条回应并出送检报告',
        text: '品牌官方发布对比长图，逐条回应成分争议，同时委托第三方机构对相关批次送检，公开检测进度。',
      },
      {
        date: '2026-08-28',
        tag: '进展',
        title: '电商详情页更新说明',
        text: '品牌更新商品详情页，补充成分百分比区间说明与质检编码，同时就此前回复口径不一致致歉。',
      },
      {
        date: '2026-09-01',
        tag: '后续',
        title: '送检结果公开舆情回落',
        text: '第三方送检结果公布，与标签大体一致，相关讨论热度回落，事件进入收尾阶段。',
      },
    ],
  },
  {
    id: 'concert-ticket',
    title: '巡演连开三场票务系统风波',
    category: '演出票务',
    status: '持续更新',
    heat: 87,
    started: '2026-08-22',
    updated: '2026-09-03',
    summary:
      '热门巡演三场连开，开票瞬间大量用户遭遇排队卡顿与“锁票未成功”，退票与转赠规则引发争议，主办方与票务平台先后发布优化与补偿方案。',
    followText: '平台已修复异常并推出候补购票，退票手续费规则进入复议流程。',
    tags: ['演唱会', '票务', '抢票系统'],
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20interior%20of%20an%20empty%20concert%20hall%20with%20rows%20of%20warm%20red%20velvet%20seats%20facing%20a%20grand%20stage%20glowing%20with%20golden%20warm%20lights%2C%20dramatic%20warm%20atmosphere%2C%20cream%20and%20amber%20palette%2C%20high%20detail%20architectural%20photography%2C%20no%20people%2C%20no%20text&width=800&height=500&seq=ev-ticket-04&orientation=landscape',
    coverAlt: '巡演票务系统风波事件封面',
    nodes: [
      {
        date: '2026-08-22',
        tag: '爆发',
        title: '开票瞬间系统卡顿',
        text: '三场同时开票后，多数用户反映停留在排队页超时，部分人付款后订单状态异常，相关吐槽迅速登上热搜。',
      },
      {
        date: '2026-08-24',
        tag: '发酵',
        title: '“锁票未成功仍扣款”争议',
        text: '有用户晒出“锁票成功却超时取消”的短信与扣款记录，票务平台客服涌入大量问询，引发对候补机制的讨论。',
      },
      {
        date: '2026-08-27',
        tag: '关键节点',
        title: '平台发布技术说明与补偿',
        text: '票务平台公布故障原因说明，对受影响账号开放优先购与小额补偿，主办方同步加开“候补购票”通道。',
      },
      {
        date: '2026-09-03',
        tag: '进展',
        title: '退票手续费规则复议',
        text: '针对非本人原因造成的异常订单，主办方宣布免收退票手续费并开通人工核验通道，事件进入收尾。',
      },
    ],
  },
  {
    id: 'food-review-backfire',
    title: '百万探店博主测评「翻车」风波',
    category: '探店测评',
    status: '发酵中',
    heat: 76,
    started: '2026-09-01',
    updated: '2026-09-06',
    summary:
      '一条被质疑“掐头去尾、夸大口感”的探店视频走红后，多位线下食客实拍验证并点名反驳，博主删改旧作并回应称将重做标准测评，讨论转向探店内容真实性。',
    followText: '博主已下架争议视频并启动重测计划，同行集体发声，行业内容真实性成为新焦点。',
    tags: ['探店', '测评真实性', '内容诚信'],
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20food%20flat%20lay%20of%20several%20appetizing%20street%20food%20bowls%20on%20a%20warm%20wooden%20table%20with%20chopsticks%2C%20a%20smartphone%20tripod%20and%20camera%20gear%20in%20frame%2C%20steam%20rising%2C%20warm%20cream%20and%20amber%20tones%2C%20natural%20light%2C%20cozy%20restaurant%20ambience%2C%20high%20detail%20food%20photography%2C%20no%20people%20faces%2C%20no%20text&width=800&height=500&seq=ev-food-05&orientation=landscape',
    coverAlt: '探店博主测评翻车风波事件封面',
    nodes: [
      {
        date: '2026-09-01',
        tag: '爆发',
        title: '实拍对比视频走红',
        text: '多名线下食客拍摄同款菜品的真实出餐，与博主视频中的“夸张效果”对比，质疑其使用滤镜与摆拍，播放量快速上升。',
      },
      {
        date: '2026-09-03',
        tag: '发酵',
        title: '旧作被集中考古',
        text: '网友翻出该博主早期多条“全好评”探店视频，指出其存在接单痕迹，讨论从单个视频扩大到账号可信度。',
      },
      {
        date: '2026-09-05',
        tag: '关键节点',
        title: '博主删改视频并回应',
        text: '博主下架争议视频，发布回应称部分画面确实存在后期处理失当，宣布暂停商业合作并重做标准测评流程。',
      },
      {
        date: '2026-09-06',
        tag: '后续',
        title: '同行发起“真实探店”倡议',
        text: '多位探店创作者发起真实测评倡议，行业内容透明度成为舆论新的讨论焦点，事件仍处于发酵阶段。',
      },
    ],
  },
  {
    id: 'drama-sequel-casting',
    title: '热播剧续作换角传闻事件',
    category: '明星动态',
    status: '已告一段落',
    heat: 68,
    started: '2026-07-20',
    updated: '2026-08-14',
    summary:
      '某热播剧续作筹备期间，网传主角可能更换，引发剧粉与原班人马粉丝的密集讨论，片方最终在开机前官宣阵容并说明档期原因。',
    followText: '片方已官宣完整阵容，传言澄清后热度回落，事件告一段落。',
    tags: ['影视剧', '演员阵容', '片方回应'],
    cover: 'https://readdy.ai/api/search-image?query=Editorial%20movie%20set%20atmosphere%20with%20director%20monitor%2C%20clapperboard%20and%20production%20notes%2C%20soft%20golden%20practical%20lights%20in%20background%2C%20warm%20cream%20and%20amber%20palette%2C%20film%20grain%20texture%2C%20cinematic%20composition%2C%20high%20detail%2C%20no%20recognizable%20people%2C%20no%20text&width=800&height=500&seq=ev-drama-06&orientation=landscape',
    coverAlt: '热播剧续作换角传闻事件封面',
    nodes: [
      {
        date: '2026-07-20',
        tag: '爆发',
        title: '选角传闻在剧粉圈发酵',
        text: '有娱乐号爆料续作考虑更换领衔主演，称与档期冲突有关，消息在超话与剧粉社群快速扩散。',
      },
      {
        date: '2026-07-24',
        tag: '发酵',
        title: '“原班人马”话题被刷上热搜',
        text: '剧粉发起保留原阵容的话题，阅读量破亿，多方截图流出但均未获证实，片方保持沉默。',
      },
      {
        date: '2026-08-05',
        tag: '关键节点',
        title: '片方预告近期官宣',
        text: '官方账号发布“主创见面”倒计时海报，被解读为即将公布阵容，二手信息量随之减少。',
      },
      {
        date: '2026-08-12',
        tag: '进展',
        title: '开机前官宣完整阵容',
        text: '片方召开发布会官宣阵容，主角确认为原班人马，因档期调整加入数位新角色，并澄清早前传言不实。',
      },
      {
        date: '2026-08-14',
        tag: '收尾',
        title: '舆情归于平稳',
        text: '阵容公布后，讨论转向剧情猜测与定档期待，换角传闻告一段落，事件由“待解”转为“已澄清”。',
      },
    ],
  },
];